import React from "react";
import { Field } from "formik";
import { SingleSelect } from "@coverme/forms";
import { first } from "lodash-es";

export const insuranceCompanyTypes = [
    { label: "AARP Medicare Supplement Plans", value: "AARP Medicare Supplement Plans" },
    { label: "Aetna", value: "Aetna" },
    { label: "Blue Cross of Mississippi", value: "Blue Cross of Mississippi" },
    { label: "Cigna", value: "Cigna" },
    { label: "Humana", value: "Humana" },
    { label: "Magnolia", value: "Magnolia" },
    { label: "United Healthcare", value: "United Healthcare" },
    { label: "Other", value: "Other" },
];

export const CoveragePrivateSelect = ({
    name,
    id,
    errors,
    touched,
    setFieldValue,
    title,
    setFieldTouched,
    getErrors = () => {},
    getValidationState = () => {},
    isRequired,
}) => {
    const options = insuranceCompanyTypes;
    if (isRequired == null) {
        isRequired = () => false;
    }

    return (
        <Field
            name={name}
            render={({ field }) => {
                const selectedValue = first(options.filter(x => x.value == field.value));
                return (
                    <SingleSelect
                        title={title || `Private company name: `}
                        value={selectedValue}
                        id={id}
                        onChange={e => {
                            setFieldValue(name, e.value);
                        }}
                        options={options}
                        required={isRequired(field)}
                        validState={getValidationState(field)}
                        errorMessage={getErrors(field)}
                        onBlur={() => setFieldTouched(name)}
                    />
                );
            }}
        />
    );
};
